import * as S from './style';
import ArrowRightIcon from '@/components/Icon/ArrowRightIcon';
import { mypageMenuList } from '@/constants/menu';
import { useLocation, useNavigate } from 'react-router-dom';
import BasicInfo from '@/components/MyPage/BasicInfo/BasicInfo';
import useIsMobile from '@/hooks/useIsMobile';
import CompanyInfo from '@/components/MyPage/CompanyInfo/CompanyInfo';
import EducationInfo from '@/components/MyPage/EducationInfo/EducationInfo';
import EtcInfo from '@/components/MyPage/EtcInfo/EtcInfo';
import ModifyPassword from '@/components/MyPage/ModifyPassword/ModifyPassword';
import ServiceTerms from '@/components/MyPage/ServiceTerms/ServiceTerms';
import PrivacyTerms from '@/components/MyPage/PrivacyTerms/PrivacyTerms';
import AccountExit from '@/components/MyPage/AccountExit/AccountExit';
import uuid from 'react-uuid';
import { useLogoutApi } from '@/api/auth';
import { useAuthStore } from '@/store/authStore';
const MyPage = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const { name } = useAuthStore();
	const { mutateAsync: logout } = useLogoutApi();
	const isMobile = useIsMobile(900);

	const params = location.state?.menu ?? '기본정보';

	const handleLogout = async () => {
		await logout();
	};
	return (
		<main>
			<S.Container>
				{!isMobile && <S.Title>마이페이지</S.Title>}

				<S.Main>
					{!isMobile && (
						<S.Aside>
							<div className="info">
								<p className="title">{name} 님</p>
								<S.LogoutButton type="button" onClick={handleLogout}>
									로그아웃
									<ArrowRightIcon iconColor="#fff" width="16" height="16" />
								</S.LogoutButton>
							</div>

							<S.MenuBoxList>
								{mypageMenuList.map((m) => (
									<S.MenuBox
										className={params === m.menu || (params === '회원탈퇴' && m.menu === '기본정보') ? 'active' : ''}
										key={uuid()}
										onClick={() => navigate('/mypage', { state: { menu: m.menu } })}
									>
										{m.menu}
									</S.MenuBox>
								))}
							</S.MenuBoxList>
						</S.Aside>
					)}

					<S.MainContent>
						{params === mypageMenuList[0].menu && <BasicInfo />}
						{params === mypageMenuList[1].menu && <CompanyInfo />}
						{params === mypageMenuList[2].menu && <EducationInfo />}
						{params === mypageMenuList[3].menu && <EtcInfo />}
						{params === mypageMenuList[4].menu && <ModifyPassword />}
						{params === mypageMenuList[5].menu && <ServiceTerms />}
						{params === mypageMenuList[6].menu && <PrivacyTerms />}
						{params === '회원탈퇴' && <AccountExit />}
					</S.MainContent>
				</S.Main>
			</S.Container>
		</main>
	);
};
export default MyPage;
